import { createStateFactory } from '@pogokid/react-hooks'

export const appUiStateFactory = createStateFactory('AppUi', {
  /** Main screen title displayed in the header */
  screenTitle: null as string | null,
  /** Currently open global modal dialog */
  globalDialog: null as 'search' | 'add-student' | null,
  /** Controls the main actions drawer visibility */
  actionsDrawerOpen: false,
})

export type GlobalDialog = ReturnType<
  typeof appUiStateFactory.useGlobalDialog
>
